<script setup lang="ts">
import { AppSvgIcon } from '@libs/ui';

import type { PeekPriceNonBookableTransportCardData } from '../../models';

interface PeekPriceNonBookableTransportCardProps {
  data: PeekPriceNonBookableTransportCardData;
}

const props = defineProps<PeekPriceNonBookableTransportCardProps>();
</script>

<template>
  <div class="peek-price-non-bookable-transport-card">
    <div class="non-bookable-transport-icon">
      <AppSvgIcon :name="props.data.icon" size="24" />
    </div>

    <div class="non-bookable-transport-content">
      <div class="non-bookable-transport-date">{{ props.data.date }}</div>
      <div class="non-bookable-transport-type">
        {{ props.data.description }}
      </div>
      <div class="non-bookable-transport-details">
        <div class="non-bookable-transport-distance">
          {{ props.data.distance }}
        </div>
        <div class="non-bookable-transport-travel-time">
          {{ props.data.travelTime }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.peek-price-non-bookable-transport-card {
  display: flex;
  gap: var(--spacing-12);
  align-items: center;

  .non-bookable-transport-icon {
    --size: 60px;
    width: var(--size);
    height: var(--size);

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .non-bookable-transport-content {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);

    .non-bookable-transport-date {
      @include font-label-s-light;
      color: var(--color-neutral-70);
    }

    .non-bookable-transport-type {
      @include font-label-m-bold;
      color: var(--color-neutral-70);
    }

    .non-bookable-transport-details {
      display: flex;

      .non-bookable-transport-distance {
        @include font-label-s-light;
        color: var(--color-neutral-70);
        padding-right: var(--spacing-12);
        margin-right: var(--spacing-12);
        border-right: 1px solid var(--color-neutral-20);
      }

      .non-bookable-transport-travel-time {
        @include font-label-s-light;
        color: var(--color-neutral-70);
      }
    }
  }
}
</style>
